// extracted by mini-css-extract-plugin
export default {"drawer":"UploadDocumnetDrawer_drawer__M3NGm"};